module.exports = __webpack_public_path__ + "img/chinesecompany123.bb067575.png";